import React from 'react'
import { ChevronRightIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { WholesalerCard } from './WholesalerCard'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'

export const TopWholesalersSection = () => {
  const { data: wholesalersData } = useQuery({
    queryKey: QueryKeys.topWholesalers(),
    queryFn: () => handleGetRequest('/top-wholesellers'),
    retry: 1,
  })
  const topWholesalers = wholesalersData?.data || []

  if (topWholesalers.length === 0) {
    return null
  }

  return (
    <div className="bg-background main-container py-4 border-b border-dashed border-black/50">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-extrabold text-black capitalize">Top Wholesaler shops</h2>
        <Link to="/wholesellers" aria-label="View all wholesalers">
          <ChevronRightIcon className="h-6 w-6 text-secondary-600" />
        </Link>
      </div>

      <div className="py-4">
        <Swiper
          modules={[FreeMode]}
          spaceBetween={16}
          slidesPerView="auto"
          freeMode={{
            enabled: true,
            sticky: false,
          }}
          watchSlidesProgress={true}
          className="swiper-container"
          breakpoints={{
            320: {
              slidesPerView: 2.5,
              spaceBetween: 12,
            },
            640: {
              slidesPerView: 3.5,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 4.5,
              spaceBetween: 16,
            },
          }}
        >
          {topWholesalers.map((wholesaler) => (
            <SwiperSlide key={wholesaler.userId} className="!w-auto">
              <WholesalerCard wholesaler={wholesaler} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <Link
        to="/wholesellers"
        className="mt-6  block rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-600"
      >
        <div className="mt-6 mx-4 flex items-center justify-between p-4 rounded-md bg-gradient-to-r from-tertiary-700 to-tertiary-600">
          <div>
            <p className="text-lg font-black text-white">Don't see you favorite</p>
            <p className="text-base font-medium text-white">Find Wholesaler shop Now!</p>
          </div>
          <MagnifyingGlassIcon className="h-8 w-8 text-white flex-shrink-0 ml-2" />
        </div>
      </Link>
    </div>
  )
}
